import { Injectable } from '@angular/core';
import { Companies, Company, Questions } from 'models';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  
  private questions: Questions = undefined;
  private companies: Companies = undefined;
  private totalProducts: number = undefined;

  constructor() { }

  setQuestions(fQuestions: Questions) {
    this.questions = this.resetQuestions(fQuestions);
  }

  getQuestions() {
    return this.resetQuestions(this.questions)
  }

  private resetQuestions(fQuestions: Questions): Questions {
    if (fQuestions) {
      return fQuestions.map(q => {
        if (q.answers) {
          q.answers = q.answers.map(a => { 
            a.isSelected = false;
            a.minValue = undefined;
            a.maxValue = undefined;
            a.value1 = undefined;
            a.value2 = undefined;
  
            return {...a}
          })
        }
  
        return {...q}
  
      })
    }

    return undefined
  }
  
  setCompanies(fCompanies) {
    this.companies = [...fCompanies]
  }

  getCompanies(): Companies {
    return this.companies ? [...this.companies] : undefined
  }

  setTotalProducts(fTotal: number) {
    this.totalProducts = fTotal;
  }

  getTotalProducts(): number {
    return this.totalProducts
  }
}
